<template id="">
    <div v-if="role">
        <div v-if="role == 'admin' || role == 'super-admin' || role == 'group-admin' ">
            <admin-desktop-nav></admin-desktop-nav>
            <admin-mobile-nav></admin-mobile-nav>
        </div>
        <div v-if="role == 'user'">
            <user-desktop-nav></user-desktop-nav>
            <user-mobile-nav></user-mobile-nav>
        </div>

        <div v-if="role == 'manager'">
            <manager-desktop-nav></manager-desktop-nav>
            <manager-mobile-nav></manager-mobile-nav>
        </div>
    </div>

    <div v-if="role == 'auto-login'">
        <no-user-desktop-nav></no-user-desktop-nav>
        <no-user-mobile-nav></no-user-mobile-nav>
    </div>
</template>

<script>
    import Vuex from 'vuex';
    import NoUserDesktopNav from './NoUserDesktopNav.vue';
    import NoUserMobileNav from './NoUserMobileNav.vue';
    import UserDesktopNav from './UserDesktopNav.vue';
    import UserMobileNav from './UserMobileNav.vue';
    import AdminDesktopNav from './AdminDesktopNav.vue';
    import AdminMobileNav from './AdminMobileNav.vue';
    import ManagerDesktopNav from './ManagerDesktopNav.vue';
    import ManagerMobileNav from './ManagerMobileNav.vue';

    export default {
        name: 'Navigation',

        components: {
            NoUserDesktopNav,
            NoUserMobileNav,
            UserDesktopNav,
            UserMobileNav,
            AdminDesktopNav,
            AdminMobileNav,
            ManagerDesktopNav,
            ManagerMobileNav,
        },

        computed: {
            ...Vuex.mapGetters('profile', {
                role: 'role',
            }),
        }
    }
</script>
